<script setup lang="ts">
import { toRef } from 'Vue'

const props = defineProps<{
	filter: PartChoiceFilter;
	value: string;
	onFilterChange: (name: string, value: string) => void;
}>()

const value = toRef(props, 'value')

const filter = props.filter
const onFilterChange = props.onFilterChange

const onChange = function(e: any) {
	onFilterChange(filter.label, e.target.value)
}

const uid = Math.floor(Math.random() * (99999999 - 10000000) + 10000000)

</script>

<template>
	<div class="product-filter" v-if="filter.options.length > 1">
		<label :for="`product-filter-${uid}-select`">{{filter.label}}</label>

		<select class="product-filter__select" :id="`product-filter-${uid}-select`" :onChange="onChange">
			<option value="">- Vis alle -</option>

			<option
				v-for="option in filter.options"
				:value="option"
				:selected="option == value"
			>{{option}}</option>
		</select>
	</div>
</template>

<style lang="scss" scoped>
.product-filter {
	$block: '.product-filter';

	#{$block} {
		&__select {
			margin-bottom: 0;
			padding-right: 28px;
			background-image: url('./../../svg/select-arrow.svg');
			background-repeat: no-repeat;
			background-position: right 0.75rem center;
			background-size: 16px 12px;
		}
	}
}
</style>
